import React from "react";
import { Col, Row } from "react-bootstrap";

function SearchResultsNotFound() {
  return (
    <Row className="search-results-not-found-container mx-0 my-3 py-3">
      <Col className="d-flex flex-column justify-content-center align-items-center px-0">
        <p className="search-results-text">No mappings found.</p>
        <p className="search-results-note">Try changing your filters.</p>
      </Col>
    </Row>
  );
}

export default SearchResultsNotFound;
